module.exports = __webpack_public_path__ + "static/media/om.e11e2bc1.svg";